import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ActiveColor, Color, ColorPickerFilterForm } from './color-picker.interfaces';
import { ColorFilterBase, PhoneDetailsColorDTO } from '../../../modules/devices/phone.interfaces';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorPickerComponent),
      multi: true,
    },
  ],
})
export class ColorPickerComponent implements OnInit, ControlValueAccessor {
  @Input() colors: Color[];
  @Input() colorFilter: ColorFilterBase;
  @Input() activeColorId: number;

  @Output() activeColorChanged = new EventEmitter<PhoneDetailsColorDTO>();

  colorList: ActiveColor[];

  activeColor: ActiveColor;

  formArray = this.fb.array([]);
  _destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.colorFilter) {
      this.colorFilter.searchFilters.forEach((filters) => {
        this.formArray.push(
          this.fb.group({
            name: this.fb.control(filters.name),
            hexCode: this.fb.control(filters.colorCode),
            active: this.fb.control(false),
          })
        );
      });

      this.formArray.valueChanges
        .pipe(
          takeUntil(this._destroy$),
          map((value: ColorPickerFilterForm[]) => value.filter((color) => color.active).map((color) => color.name))
        )
        .subscribe((value) => {
          this.onChange(value);
        });
    } else {
      this.colorList = this.colors.map((color, index) => ({ ...color, active: false }));
      this.activeColor =
        this.colorList.find((color) => color.data.keszulekSzinId === this.activeColorId) || this.colorList[0];
      this.activeColor.active = true;
    }
  }

  onColorClicked(color: ActiveColor): void {
    // FIXME: Amint lesznek értelmes hexCode-ok, az összehasonlítást ki kell javítani
    if (!this.activeColor || color.name !== this.activeColor.name) {
      color.active = true;
      this.activeColor = color;
      // TODO check this modification
      // this.activeColor.active = false;
      this.activeColorChanged.emit(color.data);
    }
  }

  onColorFilterClicked(colorForm: FormGroup): void {
    colorForm.patchValue({ active: !colorForm.get('active').value });
  }

  onChange(fn: any): void {
    //
  }

  onTouched(fn: any): void {
    //
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(activeColorNames: string[]): void {
    activeColorNames?.forEach((colorName) => {
      this.formArray.controls.find((control) => control.get('name').value === colorName).patchValue({ active: true });
    });
  }
}
